/**
 * Normalizadores wire → *Local para los endpoints `/applications/*`.
 *
 * El wire shape coincide con el contrato generado (`backoffice.gen.ts`); la única transformación
 * es epoch ms (number) → ISO string en los timestamps, para que la UI renderice fechas sin tocar
 * `Date` en cada componente. Siempre con defaults (nunca dejan un campo requerido en `undefined`),
 * igual que `platformNormalizers.ts`. Se aplican dentro de `applicationApi.*`.
 */
import type {
    ApplicationWire,
    ApplicationPermissionWire,
    ApplicationListItemLocal,
    ApplicationDetailLocal,
    ApplicationPermissionLocal,
} from './ApplicationLocal';

/** epoch ms (number) | nulo → ISO string (o '' si no hay dato). */
function toIso(value: number | null | undefined): string {
    if (value === undefined || value === null) return '';
    return new Date(value).toISOString();
}

export function normalizeApplicationListItem(wire: ApplicationWire): ApplicationListItemLocal {
    return {
        applicationId: wire.applicationId,
        displayName: wire.displayName,
        levels: wire.levels,
        seedRoles: wire.seedRoles,
        status: wire.status,
        createdAt: toIso(wire.createdAt),
        updatedAt: toIso(wire.updatedAt),
    };
}

export function normalizeApplicationList(wire: { items?: ApplicationWire[] }): {
    items: ApplicationListItemLocal[];
} {
    return { items: (wire.items ?? []).map(normalizeApplicationListItem) };
}

export function normalizeApplicationDetail(wire: ApplicationWire): ApplicationDetailLocal {
    return {
        ...normalizeApplicationListItem(wire),
        defaults: wire.defaults,
    };
}

export function normalizeApplicationPermission(
    wire: ApplicationPermissionWire,
): ApplicationPermissionLocal {
    return {
        applicationId: wire.applicationId,
        permissionKey: wire.permissionKey,
        displayName: wire.displayName,
        description: wire.description,
        scope: wire.scope,
        kind: wire.kind,
        category: wire.category,
        createdAt: toIso(wire.createdAt),
        updatedAt: toIso(wire.updatedAt),
    };
}

export function normalizeApplicationPermissionList(wire: { items?: ApplicationPermissionWire[] }): {
    items: ApplicationPermissionLocal[];
} {
    return { items: (wire.items ?? []).map(normalizeApplicationPermission) };
}
